import React from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';

export default function CustomDate(props) {
    return (
        <div className="">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    margin="normal"
                    clearable={props.clearable}
                    label={props.label}
                    format="dd/MM/yyyy"
                    value={props.value}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    helperText={props.helperText}
                    error={props.error}
                    required={props.required}
                    disabled={props.disabled}
                    onChange={(date) => {
                        props.setValue(date)
                    }}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    style={{ width: '100%' }}
                    inputProps={{ style: { fontSize: 14 } }}
                    InputProps={{
                        style: {
                            fontSize: 14,
                        }
                    }}
                    InputLabelProps={{
                        style: {
                            fontSize: 14,
                            color: '#7e8085',
                        }
                    }}
                />
            </MuiPickersUtilsProvider>
        </div>
    )
}
